import { cn } from '@/libs/tw'
import { useCartStore } from '@/stores/cart-store/cartStore'

import { RoomContextProvider } from '../context/roomContext'
import { RoomSummary } from './roomSummary'

export const RoomSelectionSummary = () => {
	const { selectedRooms } = useCartStore.use.roomSelection()
	const roomConfigurations = useCartStore.use.roomConfigurations()
	return (
		<div
			className={cn(
				'flex flex-col gap-24',
				'md:grid md:grid-cols-2 md:items-start lg:grid-cols-3 xl:grid-cols-4'
			)}
		>
			{selectedRooms.map((room, index) => {
				const config = roomConfigurations.find((config) => config.id === room.roomConfigId)
				if (!config) return null

				return (
					<RoomContextProvider
						key={'roomSummary' + config.id}
						roomNumber={index + 1}
						roomConfig={config}
					>
						<RoomSummary room={room.room} />
					</RoomContextProvider>
				)
			})}
		</div>
	)
}
